import { InputAdornment, type SxProps, TextField, type Theme } from '@mui/material';
import React from 'react';

interface CurrencyInputProps {
    value: number;
    disabled?: boolean;
    helperText?: string;
    sx?: SxProps<Theme>;
    onChange(val: number): void;
}

/**
 * Modern CurrencyInput component with MUI styling.
 * @param {CurrencyInputProps} props - The props for the currency input.
 * @returns {JSX.Element} The rendered CurrencyInput component.
 */
export default function CurrencyInput(props: CurrencyInputProps) {
    return (
        <TextField
            variant="outlined"
            size="small"
            type="number"
            disabled={props.disabled}
            value={props.value?.toString() || ''}
            helperText={props.helperText}
            onChange={(e) => props.onChange(parseFloat(e.target.value) || 0)}
            InputProps={{
                inputProps: {
                    min: 0,
                    step: 0.01,
                },
                endAdornment: <InputAdornment position="end">€</InputAdornment>,
            }}
            sx={{
                width: 'auto',
                minWidth: '120px',
                '& .MuiInputBase-input': {
                    fontSize: '0.875rem',
                },
                '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                },
                ...props.sx,
            }}
        />
    );
}
